module.exports = "# VersionOne Icons\r\nListed below are all the icon components shipped with VersionOne UI.\r\n"


//////////////////
// WEBPACK FOOTER
// ./pages/foundations/icons.md
// module id = 1274
// module chunks = 0